import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  menu: {
    margin: '0 20px',
    textDecoration: 'none',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    fontFamily: 'AvenirNext',
    fontWeight: 500,
    cursor: 'pointer',
    padding: '12px 8px',
    color: '#2A2444',
    opacity: (props) => (props.isOpacity ? 0.7 : 1),
  },
  active: {
    borderBottom: (props) => (props.borderBottom ? props.borderBottom : '3px solid #6C62F5'),
    opacity: '1 !important',
  },
}));
